<template>
    <!-- Bottom of an editor's outline sidebar: latest comments and the sign-off count -->
    <div class="ep-side-h" style="margin-top:18px">Activity</div>
    <div class="ep-ol ep-ol-static">
        <svg viewBox="0 0 24 24"><path d="M8 9h8M8 13h6M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-5l-5 3v-3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h12z" /></svg>{{ comments.length }} comment{{ comments.length == 1 ? '' : 's' }}
    </div>
    <div v-for="comment in comments.slice(0, 2).reverse()" :key="comment.ID" class="ep-cmt"><b>{{ `${comment.User}`.split(' ')[0] }}</b> {{ `${comment.Comment}`.slice(0, 90) }}</div>
    <div class="ep-side-n">
        <svg viewBox="0 0 24 24"><path d="M3 17c3.33-3.33 5-6 5-8a3 3 0 0 0-6 0c0 3 3 4.5 4.5 6.5C7.5 16.8 8.3 18 9 18c1.5 0 2.5-3 3-3s1 2 2.5 2c.6 0 1.6-.6 2.5-2M17 20h4" /></svg>{{ signedCount }} of {{ requiredCount }} signed v{{ version }}
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'EditorActivity',
    // comments: newest first, as the comments API returns them
    props: [ 'comments', 'signedCount', 'requiredCount', 'version' ]
});
</script>
